import { createContext } from 'react';
import { computed, observable, makeObservable } from 'mobx';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { EventListState } from '../../../components/organisms/events/states/EventListState';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { getLocationSelector, getOnlineSelector } from '../../../components/molecules/forms/LocationSelector';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { SheLocation } from '../../../types/location';
import { LocationApis } from '../../../apis/locations';

export class EventsPageState {
  locations: RemoteResourceV3<SheLocation[]> = RemoteResourceV3.loading();
  initialized = false;
  eventList: EventListState = new EventListState();
  archivedEventList: EventListState = new EventListState();
  initState = new SubmitState();

  constructor() {
    makeObservable(this, {
      locations: observable,
      initialized: observable,
      loading: computed,
    });
  }

  async init() {
    const { currentUser } = GlobalStatesV3;
    await this.initState.operate(async () => {
      await Promise.all([this.eventList.init(), this.archivedEventList.init(), this.reloadLocations()]);
      const { isHomeLocationSet, isCurrentLocationOnline, locationId } = currentUser.homeLocation;
      const defaultLocations =
        isHomeLocationSet && !isCurrentLocationOnline
          ? [getLocationSelector(locationId), getOnlineSelector()]
          : [getOnlineSelector()];
      this.eventList.setSelectedLocationSelectors([...defaultLocations]);
      this.archivedEventList.setSelectedLocationSelectors([...defaultLocations]);
    });
    this.initialized = true;
  }
  get loading() {
    return this.initState.submitting;
  }

  async reloadLocations() {
    await updateRemoteResourceV3<SheLocation[]>(
      this.locations,
      (v) => (this.locations = v),
      () => LocationApis.findAll()
    );
  }

  get currentUser() {
    return GlobalStatesV3.currentUser;
  }

  get location() {
    return GlobalStatesV3.currentUser.homeLocation;
  }
}

export const EventsPageContext = createContext(new EventsPageState());
